import { useNavigate } from 'react-router-dom';
import { PublicLayout } from '@/components/layout/PublicLayout';


export default function PrivacyPolicy() {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/login');
    }
  };

  return (
    <PublicLayout>
      <article className="legal-card">
        <header className="legal-card__header">
          <h1>Privacy Policy</h1>
          <button type="button" className="btn btn-secondary" onClick={handleBack}>Back</button>
        </header>
        <div className="legal-card__content">
          <p>
            This software uses cloud services and AI/LLM technologies to process your inputs. Data may be transmitted to external systems for computation.
          </p>
          <p>
            Please avoid submitting sensitive, confidential, or regulated information. The Company and its developers make no guarantees regarding confidentiality, security, accuracy, retention and conclusions of any data processed through AI or cloud components.
          </p>
          <p>
            By using this software, you acknowledge and accept full responsibility for all data you enter, upload, or generate, and agree that the Company is not liable for any loss, misuse, disclosure, or reliance on AI-generated outputs.
          </p>
        </div>
      </article>
    </PublicLayout>
  );
}
